import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import React from "react";
import { withTranslation } from "react-i18next";
import applicationFeeConfigService from "../../../services/applicationFeeConfigService";
import degreeService from "../../../services/degreeService";
import logger from "../../../services/logger";
import specializationService from "../../../services/specializationService";
import { getDynamicFormJson } from "../../common/dynamicFormService";
import Form from "../../common/form";
import {
  getFormButtonText,
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../../common/formUtils";

class AdmissionFeeConfigForm extends Form {
  constructor() {
    super();
    this.formJson = getDynamicFormJson("addmissionFeeConfig");
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }

  getDegrees = async () => {
    try {
      const { data } = await degreeService.getPrograms();
      const dropDowns = this.state.dropDowns;
      dropDowns.degrees = data;
      this.setState({ dropDowns });
    } catch (ex) {
      logger.error("programs ", ex);
    }
  };

  getDepartments = async (degreeId) => {
    try {
      const { data } = await specializationService.getSpecializationsByDegree(
        degreeId
      );
      const dropDowns = this.state.dropDowns;
      dropDowns.depts = data;
      this.setState({ dropDowns });
    } catch (ex) {
      logger.error("programs ", ex);
    }
  };

  onSelectOf = async (item, value) => {
    
    switch (item) {
      case "degreeId":
        await this.getDepartments(value);
        break;
    }
  };

  async populateForm() {
    const id = this.props.match.params.id;
    if (id === "new") return;
    try {
      const { data } = await applicationFeeConfigService.get(id);
      this.mapToViewModel(data);
    } catch (ex) {
      logger.error(ex);
    }
  }

  async componentDidMount() {
    await this.populateForm();
    await this.getDegrees();
    // this.getEnumValue();
  }

  doSubmit = async (id) => {
    try {
      if (id === "new") {
        await applicationFeeConfigService.create(this.state.data);
      } else {
        await applicationFeeConfigService.update(this.state.data);
      }
      this.props.history.push("/admission-fee-configs");
    } catch (ex) {
      logger.log(ex);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.match.params.id;

    const buttonText = getFormButtonText(id);

    const titleText = getFormTitleText(id, this.formJson.alias);

    return (
      <Card>
        <form onSubmit={(event) => this.handleSubmit(event, id)}>
          <CardHeader title={t(titleText)} />

          {this.renderForm(this.formJson, dropDowns)}

          <CardContent>
            <Grid container item sm={12} md={12} direction="row-reverse">
              {this.renderMatButton(t(buttonText))}
              {this.renderMatButton(t("common:Reset"), "reset", "secondary")}
            </Grid>
          </CardContent>
        </form>
      </Card>
    );
  }
}

export default withTranslation(["admissionFeeConfigs", "common"])(
  AdmissionFeeConfigForm
);
